import { GravityFormsFragment } from '@/fragments/GravityForms'
import { gql } from '@apollo/client'

export const variables = ({ databaseId }, ctx) => {
  return {
    databaseId,
    asPreview: ctx?.asPreview
  }
}

export const query = gql`
  ${GravityFormsFragment}
  query GetPost($databaseId: ID!, $asPreview: Boolean = false) {
    contactForm: gfForm(id: 1, idType: DATABASE_ID) {
      ...GravityFormsFragment
    }
    caseStudy(id: $databaseId, idType: DATABASE_ID, asPreview: $asPreview) {
      id
      title
      seo {
        metaDesc
        title
      }
      terms {
        nodes {
          ... on CaseStudyService {
            name
            slug
          }
        }
      }
      flexibleContent {
        flexibleContentFields {
          ... on FlexibleContentFlexibleContentFieldsAlternatingTextAndImageLayout {
            fieldGroupName
            alternatingTextContent
            alternatingSubheading
            alternatingHeading
            alternatingContentImageFullWidth
            alternatingIcon {
              node {
                altText
                sourceUrl
              }
            }
            imageRightOrLeft
            alternatingImage {
              node {
                altText
                sourceUrl
              }
            }
          }
          ... on FlexibleContentFlexibleContentFieldsTwoColumnContentLayout {
            columnOneContent
            columnTwoContent
            fieldGroupName
          }
          ... on FlexibleContentFlexibleContentFieldsContentBlockLayout {
            description
            fieldGroupName
            heading
            subheading
          }
          ... on FlexibleContentFlexibleContentFieldsStandardContentDarkBackgroundLayout {
            description
            fieldGroupName
            heading
            subheading
          }
          ... on FlexibleContentFlexibleContentFieldsContentWithPhotoFeedLayout {
            fieldGroupName
            contentPhotoSubheading
            choiceTextOrImageheading
            contentPhotoheading
            parallaxContinuousScroll
            headingInsideBox
            logoHeading {
              node {
                altText
                sourceUrl
              }
            }
            contentPhotoDescription
            contentPhotoLinkOne {
              target
              title
              url
            }
            contentPhotoLinkTwo {
              target
              title
              url
            }
            photoFeed {
              fieldGroupName
              photo {
                node {
                  sourceUrl
                }
              }
            }
          }
        }
      }
      caseStudyFields {
        clientDate
        clientDescription
        clientIndustry
        clientLink {
          target
          title
          url
        }
        clientLogo {
          node {
            altText
            sourceUrl
          }
        }
        clientName
        conclusionDescription
        fieldGroupName
        headshotImage {
          node {
            altText
            sourceUrl
          }
        }
        heroImageVideo
        heroVideo {
          node {
            mimeType
            mediaItemUrl
          }
        }
        heroImage {
          node {
            altText
            sourceUrl
            mediaDetails {
              width
              height
            }
          }
        }
        problemDescription
        problemHeading
        problemBeforeImage {
          node {
            altText
            sourceUrl
          }
        }
        problemAfterImage {
          node {
            altText
            sourceUrl
          }
        }
        problemSubheading
        solutionDescription
        solutionHeading
        solutionImage {
          node {
            altText
            sourceUrl
          }
        }
        solutionLink {
          target
          title
          url
        }
        solutionSubheading
        testimonial
        title
      }
    }
  }
`
